import { render, staticRenderFns } from "./PriceCalculationsSearch.vue?vue&type=template&id=385ea4f2&scoped=true&"
import script from "./PriceCalculationsSearch.vue?vue&type=script&lang=js&"
export * from "./PriceCalculationsSearch.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculationsSearch.vue?vue&type=style&index=0&id=385ea4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ea4f2",
  null
  
)

export default component.exports